class ProductCard extends Theme.Component {
  static #cards = new Map();

  #request = 0;

  connectedCallback() {
    super.connectedCallback();

    (this.elements.swatches || []).forEach((swatch) => {
      this.addDirectEvent("mouseenter", swatch, () => this.prefetch(swatch));
      this.addDirectEvent("focus", swatch, () => this.prefetch(swatch));
    });
  }

  prefetch(element) {
    if (!element.dataset.url) {
      return;
    }

    this.load(element.dataset.url)
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const image = doc.querySelector('[data-element="image"]');

        if (!image) {
          return;
        }

        const preload = new Image();
        preload.sizes = image.sizes;
        preload.srcset = image.srcset;
        preload.src = image.src;
      })
      .catch(() => {});
  }

  load(variantUrl) {
    const url = new URL(variantUrl, window.location.origin);

    url.searchParams.set("section_id", "product-card");

    if (!ProductCard.#cards.has(url.href)) {
      const request = fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Unable to load product card.");
          }

          return response.text();
        })
        .catch((error) => {
          ProductCard.#cards.delete(url.href);
          throw error;
        });

      ProductCard.#cards.set(url.href, request);
    }

    return ProductCard.#cards.get(url.href);
  }

  async render(detail, element) {
    if (!element.dataset.url) {
      return;
    }

    const request = ++this.#request;

    const index = this.elements.swatches.indexOf(element);

    this.setAttribute("aria-busy", "true");

    try {
      const html = await this.load(element.dataset.url);

      if (request !== this.#request || !this.isConnected) {
        return;
      }

      const doc = new DOMParser().parseFromString(html, "text/html");
      const card = doc.querySelector("component-product-card");

      if (!card) {
        throw new Error("Product card missing from response.");
      }

      window.document.adoptNode(card);

      const image = card.querySelector('[data-element="image"]');

      if (image) {
        image.loading = "eager";
        await image.decode();
      }

      if (request !== this.#request || !this.isConnected) {
        return;
      }

      const restoreFocus = this.contains(window.document.activeElement);

      this.replaceWith(card);

      if (restoreFocus) {
        card.elements.swatches[index]?.focus({ preventScroll: true });
      }

    } catch (error) {
      if (request === this.#request) {
        console.error(error);
      }

    } finally {
      if (this.#request === request) {
        this.removeAttribute("aria-busy");
      }
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#request++;
  }
}

customElements.define("component-product-card", ProductCard);
